import {DataStoreAbstract} from "./DataStoreAbstract";
import {BaseServiceAbstract} from "./BaseServiceAbstract";
import {ApiResponse} from "../models/ApiResponse";
import {Document} from '../models/Document';

export class AppService extends BaseServiceAbstract {

    public apiUrlBase: string;

    /**
     *
     * @param dataStore
     * @param apiUrlBase
     */
    constructor(dataStore: DataStoreAbstract, apiUrlBase: string) {
        super(dataStore);
        this.apiUrlBase = apiUrlBase;
    }

    /**
     * get legal documents.
     */
    async getLegalDocuments() {
        return new Promise<Document[] | ApiResponse>((resolve, reject) => {
            fetch(this.apiUrlBase + '/v1/app/legal-documents', {
                method: 'GET',
                headers: this.getAuthHeader()
            })
                .then(res => this.factoryApiResponse(res)).then((apiResponse: ApiResponse) => {
                if (apiResponse.success) {
                    this.dataStore.storeData('legalDocuments', apiResponse.response.legalDocuments);
                    resolve(apiResponse.response.legalDocuments);
                } else {
                    reject(apiResponse);
                }
            }).catch(reject);
        });
    }
}
